"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiProfileMin } from "@/generated/models/ApiProfileMin";
import { ArtistActiveSubmissionContent } from "./ArtistActiveSubmissionContent";
import { ArtistWinningArtworksContent } from "./ArtistWinningArtworksContent";
import { ArtistPreviewModalHeader } from "./ArtistPreviewModalHeader";
import { ArtistPreviewModalTabs } from "./ArtistPreviewModalTabs";
import { useRouter, usePathname, useSearchParams } from "next/navigation";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ModalTab } from "./ArtistPreviewModal";
import { useCompactMode } from "@/contexts/CompactModeContext";
import { useMediaQuery } from "@/hooks/useMediaQuery";
interface ArtistPreviewModalContentProps {
  readonly user: ApiProfileMin;
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly isApp?: boolean | undefined;
  readonly activeTab: ModalTab;
  readonly onTabChange: (tab: ModalTab) => void;
  readonly hasWinningArtworks: boolean;
}
export const ArtistPreviewModalContent: React.FC<ArtistPreviewModalContentProps> = t0 => {
  const $ = _c(43);
  const {
    user,
    isOpen,
    onClose,
    isApp: t1,
    activeTab,
    onTabChange,
    hasWinningArtworks
  } = t0;
  const isApp = t1 === undefined ? false : t1;
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const compact = useCompactMode();
  const isSmallScreen = useMediaQuery("(max-width: 1023px)");
  const submissionCount = user.active_main_stage_submission_ids?.length || 0;
  const winnerCount = user.winner_main_stage_drop_ids?.length || 0;
  const hasActiveSubmissions = submissionCount > 0;
  const showTabs = hasActiveSubmissions && hasWinningArtworks;
  let currentContentType;
  if (showTabs) {
    currentContentType = activeTab;
  } else {
    if (hasWinningArtworks) {
      currentContentType = "winners";
    } else {
      currentContentType = "active";
    }
  }
  let t2;
  if ($[0] !== compact || $[1] !== isSmallScreen || $[2] !== onClose || $[3] !== pathname || $[4] !== router || $[5] !== searchParams) {
    t2 = drop => {
      if (searchParams) {
        const params = new URLSearchParams(searchParams.toString());
        params.set("drop", drop.id);
        router.push(`${pathname}?${params.toString()}`);
      }
      if (compact && isSmallScreen && globalThis.window !== undefined) {
        globalThis.window.dispatchEvent(new CustomEvent("single-drop:close-chat"));
      }
      onClose();
    };
    $[0] = compact;
    $[1] = isSmallScreen;
    $[2] = onClose;
    $[3] = pathname;
    $[4] = router;
    $[5] = searchParams;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleDropClick = t2;
  let t3;
  if ($[7] !== currentContentType) {
    t3 = currentContentType === "winners" && <><div className="tw-absolute tw-inset-x-0 tw-top-0 tw-h-12 tw-pointer-events-none tw-bg-[linear-gradient(180deg,rgba(255,255,255,0.04),rgba(255,255,255,0)_70%)]" /><div className="tw-absolute tw-inset-0 tw-pointer-events-none tw-backdrop-blur-[1px]" /></>;
    $[7] = currentContentType;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== currentContentType || $[10] !== isApp || $[11] !== onClose || $[12] !== submissionCount || $[13] !== user || $[14] !== winnerCount) {
    t4 = <ArtistPreviewModalHeader user={user} onClose={onClose} isApp={isApp} currentContentType={currentContentType} submissionCount={submissionCount} winnerCount={winnerCount} />;
    $[9] = currentContentType;
    $[10] = isApp;
    $[11] = onClose;
    $[12] = submissionCount;
    $[13] = user;
    $[14] = winnerCount;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== activeTab || $[17] !== onTabChange || $[18] !== showTabs) {
    t5 = showTabs && <ArtistPreviewModalTabs activeTab={activeTab} onTabChange={onTabChange} />;
    $[16] = activeTab;
    $[17] = onTabChange;
    $[18] = showTabs;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  bb0: {
    if (showTabs) {
      let t7;
      if ($[20] !== activeTab || $[21] !== handleDropClick || $[22] !== isApp || $[23] !== isOpen || $[24] !== onClose || $[25] !== user) {
        t7 = activeTab === "active" ? <ArtistActiveSubmissionContent user={user} isOpen={isOpen} onClose={onClose} isApp={isApp} /> : <ArtistWinningArtworksContent user={user} isOpen={isOpen} onDropClick={handleDropClick} />;
        $[20] = activeTab;
        $[21] = handleDropClick;
        $[22] = isApp;
        $[23] = isOpen;
        $[24] = onClose;
        $[25] = user;
        $[26] = t7;
      } else {
        t7 = $[26];
      }
      t6 = t7;
      break bb0;
    }
    if (hasWinningArtworks) {
      let t7;
      if ($[27] !== handleDropClick || $[28] !== isOpen || $[29] !== user) {
        t7 = <ArtistWinningArtworksContent user={user} isOpen={isOpen} onDropClick={handleDropClick} />;
        $[27] = handleDropClick;
        $[28] = isOpen;
        $[29] = user;
        $[30] = t7;
      } else {
        t7 = $[30];
      }
      t6 = t7;
      break bb0;
    }
    let t7;
    if ($[31] !== isApp || $[32] !== isOpen || $[33] !== onClose || $[34] !== user) {
      t7 = <ArtistActiveSubmissionContent user={user} isOpen={isOpen} onClose={onClose} isApp={isApp} />;
      $[31] = isApp;
      $[32] = isOpen;
      $[33] = onClose;
      $[34] = user;
      $[35] = t7;
    } else {
      t7 = $[35];
    }
    t6 = t7;
  }
  let t7;
  if ($[36] !== t5 || $[37] !== t6) {
    t7 = <div className="tw-flex-1 tw-overflow-y-auto tw-scrollbar-thin tw-scrollbar-thumb-iron-500 tw-scrollbar-track-iron-800 hover:tw-scrollbar-thumb-iron-300 tw-relative">{t5}{t6}</div>;
    $[36] = t5;
    $[37] = t6;
    $[38] = t7;
  } else {
    t7 = $[38];
  }
  let t8;
  if ($[39] !== t3 || $[40] !== t4 || $[41] !== t7) {
    t8 = <div className="tailwind-scope tw-relative tw-rounded-xl tw-overflow-hidden tw-bg-[#0E1012] tw-border tw-border-white/5 tw-shadow-[0_10px_40px_rgba(0,0,0,0.55)]">{t3}{t4}{t7}</div>;
    $[39] = t3;
    $[40] = t4;
    $[41] = t7;
    $[42] = t8;
  } else {
    t8 = $[42];
  }
  return t8;
};